module.exports = __webpack_public_path__ + "static/img/baoxian2.06e149bc.png";